/**
 * State used in rendering Tag
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
